import React from "react";
import {
  handleChange,
  handleChangeFile,
} from "../../../helpers/handleFormChanges";
import CommonModal from "../../../components/Common/CommonModal";
import CommonButton from "../../../components/buttons/CommonButton";
import CommonInputFile from "../../../components/forms/CommonInputFile";
import CommonInputDate from "../../../components/forms/CommonInputDate";
import PropTypes from "prop-types";

function AprovarAdmissaoModal({
  isOpen,
  setIsOpen,
  valuesHook,
  aprovarAdmissao,
}) {
  const { values, setValues } = valuesHook;

  return (
    <CommonModal
      title={"Aprovar admissão"}
      is_open_modal={isOpen}
      set_is_open_modal={setIsOpen}
      size="md"
      buttons={
        <CommonButton
          key={`aprovar-admissao`}
          onClick={aprovarAdmissao}
          color="success"
        >
          Aprovar admissão
        </CommonButton>
      }
    >
      {values.categoria === 1 ? (
        <>
          <div className="row">
            <div className="col-lg-8 mb-3">
              <CommonInputFile
                id="contrato_experiencia"
                onChange={(e) => handleChangeFile(e, values, setValues)}
                label="Contrato de experiência"
                accept="application/pdf"
                required
              />
            </div>
          </div>
          <div className="row">
            <div className="col-lg-8 mb-3">
              <CommonInputFile
                id="solicitacao_transporte"
                onChange={(e) => handleChangeFile(e, values, setValues)}
                label="Solicitação de vale transporte"
                accept="application/pdf"
                required
              />
            </div>
          </div>
          {values.dependentes ? (
            <div className="row">
              <div className="col-lg-8 mb-3">
                <CommonInputFile
                  id="salario_familia"
                  onChange={(e) => handleChangeFile(e, values, setValues)}
                  label="Declaração de salário família e IRRF"
                  accept="application/pdf"
                  required
                />
              </div>
            </div>
          ) : (
            <></>
          )}
        </>
      ) : (
        <>
          <div className="row">
            <div className="col-lg-8 mb-3">
              <CommonInputFile
                id="ficha_registro"
                onChange={(e) => handleChangeFile(e, values, setValues)}
                label="Ficha de registro"
                accept="application/pdf"
                required
              />
            </div>
          </div>
        </>
      )}
      <div className="row">
        <div className="col-lg-8 mb-3">
          <CommonInputDate
            id="data_admissao"
            onChange={(e) => handleChange(e, values, setValues)}
            value={values.data_admissao}
            label="Data de admissão"
            required
          />
        </div>
      </div>
    </CommonModal>
  );
}

AprovarAdmissaoModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
  aprovarAdmissao: PropTypes.func.isRequired,
};

export default AprovarAdmissaoModal;
